/**
 * 
 */
import * as mapvgl from 'mapvgl'
import AppMap from '@/components/AppMap.js'
import {
  geoRect
} from '@/common/MapTool.js'
import geoTowns from '@/components/geo-towns.js'
import {
  listEnterpriseOfTown,
  listEnterpriseGeoOfTown,
  listGreenhouseOfEnterprise
} from '@/api/enterprise.js'

function ControlDetailMap() {
  var vue
  var labels

  this.start = function (v, tcode, ecode) {
    vue = v
    const {
      map,
      view
    } = AppMap
    // 根据乡镇代码找出所有企业
    listEnterpriseOfTown(tcode).then(enterprises => {
      // 从所有企业中找出当前企业（名称、描述等）
      const {
        title,
        description
      } = enterprises.find((current, index, arr) => {
        return current.id === ecode
      })
      vue.setProfile({
        entName: title,
        entDesc: description
      })
    })
    listEnterpriseGeoOfTown(tcode).then(enterprises => {
      // 从所有企业中找出当前企业（中心点、轮廓等）
      const {
        id,
        center,
        bound,
        zoom
      } = enterprises.find((current, index, arr) => {
        return current.id === ecode
      })
      map.flyTo(new BMapGL.Point(center.lng, center.lat), zoom + 1, {
        tilt: 50,
        heading: -40,
        callback: () => {
          const coordinates = []
          bound.push(bound[0])
          bound.forEach(b => {
            coordinates.push([b.lng, b.lat])
          })
          // 企业园区地面
          const landLyr = new mapvgl.PolygonLayer({
            //cf1505
            fillColor: '#106000', // 填充颜色
            lineWidth: 0,
            enablePicked: false, // 是否可以拾取
          })
          view.addLayer(landLyr)
          landLyr.setData([{
            type: 'Feature',
            geometry: {
              type: 'Polygon',
              coordinates: [
                coordinates
              ]
            }
          }])
          // 所有大棚
          listGreenhouseOfEnterprise(id).then(houses => {
            houses.features.forEach(f => {
              f.properties['height'] = 20
              const {
                center,
                title
              } = f.properties
              if (center && title) {
                const lbl = new BMapGL.Label(
                  `
                  <p class="town-name">${title}</p>
                  `, {
                    position: new BMapGL.Point(center[0], center[1]),
                    offset: new BMapGL.Size(-20, -40)
                  })
                lbl.setStyle({
                  borderColor: 'rgba(255,255,255,1)',
                  backgroundColor: 'rgba(50,40,60,.5)',
                  padding: '4px'
                })
                map.addOverlay(lbl)
              }
            })
            // 大棚3D块
            const hourLyr = new mapvgl.ShapeLayer({
              color: 'rgba(120, 205, 250, 0.8)', // 柱状图颜色
              enablePicked: false, // 是否可以拾取
              riseTime: 400,
              enablePicked: true, // 是否可以拾取
              selectedIndex: -1, // 选中项
              selectedColor: '#788400', // 选中项颜色
              autoSelect: true, // 根据鼠标位置来自动设置选中项
              onClick: (e) => {
                if (e && e.dataItem) {
                  vue.showHouse(e.dataItem.properties)
                }
              }
            })
            view.addLayer(hourLyr)
            hourLyr.setData(houses.features)

          })
        } //callback
      }) // map.flyTo()
    })
  }

  /**
   * 销毁之前绘制的所有内容，通常在页面切换时调用
   */
  this.destroy = function () {
    const {
      map,
      view
    } = AppMap
    view.removeAllLayers()
    map.clearOverlays()
  }
}

export default new ControlDetailMap()



// WEBPACK FOOTER //
// ./src/components/product/ControlDetailMap.js